<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementTheme']
}>()

const getDynamicPageStyles = inject('dynamicPageStyles') as (themeStyles: string) => void

getDynamicPageStyles('background-color: var(--color-brand-page-bg); color: var(--color-brand-page-color);')

// Unique ID for this component instance, stored on the Nuxt app to survive
// across instances. Vue mounts the incoming route component before unmounting
// the outgoing one, so without ownership tracking the outgoing onUnmounted
// would erase styles the incoming onMounted just applied.
const nuxtApp = useNuxtApp()
const instanceId = Symbol()

onMounted(() => {
    nuxtApp._brandThemeId = instanceId
    document.documentElement.classList.add('brand-page-color-active')
    document.documentElement.style.setProperty('--color-brand-page-color', props.content?.config?.color?.value ?? null)
    document.documentElement.style.setProperty('--color-brand-page-bg', props.content?.config?.bgColor?.value ?? null)
    document.querySelector('main')?.style.setProperty('background-color', 'var(--color-brand-page-bg)')
    document.querySelector('main')?.style.setProperty('color', 'var(--color-brand-page-color)')
})

onUnmounted(() => {
    if (nuxtApp._brandThemeId !== instanceId) return
    nuxtApp._brandThemeId = null
    document.documentElement.classList.remove('brand-page-color-active')
    document.documentElement.style.removeProperty('--color-brand-page-color')
    document.documentElement.style.removeProperty('--color-brand-page-bg')
    document.querySelector('main')?.style.removeProperty('background-color')
    document.querySelector('main')?.style.removeProperty('color')
})
</script>

<template>
    <div />
</template>
